import { useMemo } from "react";
import { useSelector } from "react-redux";
import useLanguageChange from "./useLanguageChange";
import { getNetworkQuality } from "../components/Twilio/twilioCallUtility";

const useGetNetworkQuality = () => {
    const localisedValues = useLanguageChange();
    const { localUserNetworkQuality } = useSelector((state) => state.twilioEvents);

    const localUserQualityValue = useMemo(() => {
        const networkQuality = getNetworkQuality(localUserNetworkQuality, localisedValues);
        return networkQuality;
    }, [localUserNetworkQuality]);

    return localUserQualityValue;
};

export default useGetNetworkQuality;
